export var RewardSourceFilterOperator;
(function (RewardSourceFilterOperator) {
    RewardSourceFilterOperator["EQUAL"] = "=";
    RewardSourceFilterOperator["NOT_EQUAL"] = "!=";
    RewardSourceFilterOperator["GT"] = ">";
    RewardSourceFilterOperator["LT"] = "<";
    RewardSourceFilterOperator["CONTAINS"] = "contains";
})(RewardSourceFilterOperator || (RewardSourceFilterOperator = {}));
